import {
  SEND_NOTIFICATION,
  SET_MESSAGES,
  SET_MESSAGE,
  ADD_MESSAGE
} from '../actions/notification'

const defaultState = {
  messageSent: null,
  messages: [],
  message: null,
  total: 0
}

const notificationReducer = (state = defaultState, action) => {
  switch (action.type) {
    case SEND_NOTIFICATION: {
      const { data } = action

      return {
        ...state,
        notificationSent: data,
      }
    }
    case SET_MESSAGES: {
      const { data } = action

      return {
        ...state,
        messages: data.list,
        total: data.total
      }
    }
    case ADD_MESSAGE: {
      const { data } = action

      return {
        ...state,
        messages: [data, ...state.messages.slice(0, state.messages.length - 1)],
      }
    }
    case SET_MESSAGE: {
      const { data } = action

      return {
        ...state,
        message: data,
      }
    }
    default:
      return state
  }
}

export default notificationReducer
